import { render, staticRenderFns } from "./OTextarea.vue?vue&type=template&id=5dca6174&scoped=true"
import script from "./OTextarea.vue?vue&type=script&lang=js"
export * from "./OTextarea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dca6174",
  null
  
)

export default component.exports